export default __webpack_public_path__ + "static/media/Boots of Brutal Carnage.6c980ba5.jpg";